module.exports = "<div class=\"sad\">\r\n  <span><strong>:(  </strong></span>\r\n  <span> Error occured!</span>\r\n</div>\r\n<div class=\"homepage-link\"><a routerLink=\"/sickLeaveList\">Redirect to Homepage</a></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.html
// module id = 542
// module chunks = 1